export default {
  title: 'Mes documents',
  description: 'Vos documents professionnels téléchargés. Vous pouvez les télécharger ou les remplacer à tout moment.',
  document_types: {
    owner_document: "Document d'identité du propriétaire",
    business_document: 'Document commercial',
  },
  kinds: {
    vat_registration: 'Immatriculation TVA',
    trade_registration: 'Inscription au registre du commerce',
    trade_license: 'Licence commerciale',
    commercial_register_extract: 'Extrait du registre du commerce',
    financial_statements: 'États financiers',
    other: 'Autre',
    passport: 'Passeport',
    driver_license: 'Permis de conduire',
    id_card: "Carte d'identité",
    residence_permit: 'Titre de séjour',
  },
  sides: {
    front: 'Recto',
    back: 'Verso',
  },
  fields: {
    document: 'Document',
    kind: 'Type',
    side: 'Face',
    uploaded_at: 'Téléchargé le',
    expires_at: 'Expire le',
    retained_until: "Conservé jusqu'au",
    deleted_at: 'Supprimé le',
    storage_deleted_at: 'Définitivement supprimé',
    actions: 'Actions',
  },
  values: {
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Filtrer par type de document',
    kind_placeholder: 'Filtrer par type',
  },
  retention: {
    deletable: 'Supprimable',
    tooltip:
      "La loi allemande (GoBD / §147 AO) nous oblige à conserver ce document jusqu'au {{date}}. Il ne pourra être supprimé qu'après cette date.",
    tooltip_no_date: 'Ce document est soumis à une durée de conservation légale et ne peut pas encore être supprimé.',
  },
  buttons: {
    download: 'Télécharger',
    download_front: 'Télécharger le recto',
    download_back: 'Télécharger le verso',
    reupload: 'Re-téléverser',
    delete: 'Supprimer',
  },
  empty: "Vous n'avez pas encore téléversé de documents.",
  delete_modal: {
    title: 'Supprimer le document',
    description:
      "Choisissez comment supprimer ce document. « Supprimer » l'archive et le masque de votre liste. « Supprimer définitivement » efface les fichiers de façon irréversible et n'est possible qu'une fois la durée de conservation légale écoulée.",
    delete: 'Supprimer',
    permanently_delete: 'Supprimer définitivement',
    cancel: 'Annuler',
    retention_alert:
      "Ces documents sont soumis à des durées de conservation légales en vertu du droit allemand (GoBD / §147 AO). La suppression définitive d'un document efface ses fichiers de façon irréversible.",
  },
  reupload_modal: {
    title: 'Re-téléverser le document',
    description: 'Téléversez une nouvelle version de ce document. La version précédente sera remplacée.',
    type: {
      label: 'Type de document',
      placeholder: 'Sélectionner le type de document',
    },
    kind: {
      label: 'Catégorie de document',
      placeholder: 'Sélectionner la catégorie de document',
    },
    front: {
      label: 'Recto du document',
    },
    back: {
      label: 'Verso du document (optionnel pour certains documents)',
    },
    expires_at: {
      label: "Date d'expiration du document",
      placeholder: "Sélectionner la date d'expiration",
    },
    buttons: {
      select_file: 'Sélectionner un fichier',
      submit: 'Téléverser',
      cancel: 'Annuler',
    },
  },
  toasts: {
    download_error: 'Échec du téléchargement du document.',
    delete_success: 'Document supprimé avec succès.',
    delete_error: 'Échec de la suppression du document.',
    reupload_success: 'Document téléversé avec succès.',
    reupload_error: 'Échec du téléversement du document.',
  },
};
